import { Props_SnippetContentColumnAlt } from './ContentColumnAlt.props'
import {CompileMarkdown, Legacy_CompileMarkdown} from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SwiperControls, { swiperNavigationOptions, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import {useId} from "react";
const SnippetContentColumnAlt = (props: Props_SnippetContentColumnAlt) => {
    const { heading, repeatable_entry, mainContent} = props
    const classHeadingVisibility: string = heading.visibility.value ? 'snippet-content-column-alt__heading--visible' : 'snippet-content-column-alt__heading--hidden'

    const uniqueId = useId().replace(/[^a-zA-Z0-9-_]/g, '')
    const carouselId = `snippet-content-column-alt-${uniqueId}`
    
    return (
        <section className="snippet-content-column-alt">
            <div className={`snippet-content-column-alt__container`}>
                <div className={`snippet-content-column-alt__content-container`}>
                    <h2 className={`snippet-content-column-alt__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                    {mainContent?.text?.value &&
                        <div className={`snippet-content-column-alt__main-text`}>
                            {CompileMarkdown(mainContent.text.value)}
                        </div>
                    }
                </div>
                <div className="snippet-content-column-alt__container-entries">
                    <SwiperControls
                        id={carouselId}
                        showNavigationPrev={true}
                        showNavigationNext={true}
                        showPagination={false}
                        className="snippet-content-column-alt__swiper-controls"
                    />
                    <Swiper
                        className="snippet-content-column-alt__container-slides"
                        modules={[Navigation, Pagination, A11y]}
                        navigation={{
                            ...swiperNavigationOptions,
                            prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                            nextEl: `.swiper-navigation__button-next-${carouselId}`,
                        }}
                        pagination={{
                            ...swiperPaginationOptions,
                            el: `.swiper-pagination-${carouselId}`,
                        }}
                        loop={true}
                        centerInsufficientSlides={true}
                        watchSlidesProgress={true}
                        watchOverflow={true}
                        slidesPerView={1}
                        spaceBetween={20}
                        breakpoints={{
                            630: {
                                slidesPerView: 2,
                            },
                            991: {
                                slidesPerView: 4,
                            }
                        }}
                    >
                    {repeatable_entry.map(({ image, alt, heading, content}, index: number) => (
                        <SwiperSlide key={index} className={`snippet-content-column-alt__entry`}>
                            {image?.value && (
                                <figure className="snippet-content-column-alt__entry-image-container">
                                    <img
                                        className="snippet-content-column-alt__entry-image"
                                        loading="lazy"
                                        height={190}
                                        width={350}
                                        src={image.value}
                                        alt={alt?.value ? alt.value : ''}
                                    />
                                </figure>
                            )}
                            <div className="snippet-content-column-alt__entry-content-container">
                                {heading?.value && (
                                    <>
                                        <h3 className="snippet-content-column-alt__entry-title">{heading.value}</h3>
                                    </>
                                )}
                                {content?.value && <div className="snippet-content-column-alt__entry-content">{Legacy_CompileMarkdown(content.value)}</div>}
                            </div>
                        </SwiperSlide>
                    ))}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default SnippetContentColumnAlt